export default "__VITE_ASSET__ClLwDQHu__"